import { PaginationMetadata } from '@execonline-inc/resource';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { T, TranslationsContext, translation } from '../../Translations';
import clsx from 'clsx';

interface Props {
  metadata: PaginationMetadata;
  pageFn: (page: number) => void;
}

const Previous: React.FC<Props> = ({ metadata, pageFn }) => {
  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <a
          onClick={() => pageFn(metadata.currentPage - 1)}
          className={clsx(
            'cursor-pointer relative inline-flex items-center px-2 py-2 text-teal-600',
          )}
          aria-label={translation('Previous')(ts)}
        >
          <div className="pr-2">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
          </div>
          <T kind="Prev" />
        </a>
      )}
    </TranslationsContext.Consumer>
  );
};

export default observer(Previous);
